import { GridColumnHeaderParams } from "@mui/x-data-grid-pro";

import { BooleanFilter } from "../../../../components/TableFilters/BooleanFilter";
import { DateFilter } from "../../../../components/TableFilters/DateFilter";
import { NumberFilter } from "../../../../components/TableFilters/NumberFilter";
import { TextFilter } from "../../../../components/TableFilters/TextFilter";
import { TableHeaderCell } from "../../../../components/TableHeaderCell";
import {
  removeBillingLocationsFilter,
  setBillingLocationsFilter,
  setBillingLocationsOrdering,
} from "../../../../reducers/billingLocationsReducer";
import {
  getBillingLocationsFilterIsActive,
  getBillingLocationsFilterValue,
  getBillingLocationsOrderingValue,
} from "../../../../selectors/billingLocations";
import { ColumnType } from "../billingLocationsTableColumnTypes";

const TABLE_NAME = "billingLocationsTable";

interface IHeaderCellProps {
  params: GridColumnHeaderParams;
}

const selectFilters = (type: string) => {
  switch (type) {
    case ColumnType.isActive:
    case ColumnType.isPaid:
      return (
        <BooleanFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getBillingLocationsFilterValue}
          filterUpdateAction={setBillingLocationsFilter}
        />
      );
    case ColumnType.enableTime:
      return (
        <DateFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getBillingLocationsFilterValue}
          filterUpdateAction={setBillingLocationsFilter}
        />
      );
    case ColumnType.name:
      return (
        <TextFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getBillingLocationsFilterValue}
          filterUpdateAction={setBillingLocationsFilter}
        />
      );
    case ColumnType.amount:
    case ColumnType.depositAmount:
    case ColumnType.realAmount:
    case ColumnType.balance:
    case ColumnType.currentWaste:
    case ColumnType.previousWaste:
    case ColumnType.householdMembersCount:
      return (
        <NumberFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getBillingLocationsFilterValue}
          filterUpdateAction={setBillingLocationsFilter}
        />
      );
    default:
      return <div />;
  }
};

export const BillingLocationsTableHeaderCell: React.FC<IHeaderCellProps> = ({ params }) => {
  return (
    <TableHeaderCell
      tableName={TABLE_NAME}
      params={params}
      selectorOrdering={getBillingLocationsOrderingValue}
      selectorFilterIsActive={getBillingLocationsFilterIsActive}
      removeFilterUpdateAction={removeBillingLocationsFilter}
      selectFilters={selectFilters}
      orderingUpdateAction={setBillingLocationsOrdering}
    />
  );
};
